<div class="pb--24" [class.container-xs]="mobileQuery.matches">
    <ng-container *ngIf="!loader$();else loader">
        <ng-container *ngIf="hasOrders;else noData">
            <ng-container *ngTemplateOutlet="ordersTemplate"></ng-container>
        </ng-container>
    </ng-container>


</div>

<ng-template #ordersTemplate>
    <mat-toolbar class="toolbar-filters filtersonly mb--32" >
        <div class="toolbar-actions" >
            <mat-form-field class="filter-field" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Cerca prodotto o servizio</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Cerca ..." #input>
            </mat-form-field>
        </div>
    </mat-toolbar>
      
    <mat-card>
        <mat-card-content>
            <ng-container *ngIf="hasOrders;else noData">
                <table #orderTable mat-table [dataSource]="orderDataSource"
                    class="mat-elevation-z0 mat-table-responsive style-3">

                    <ng-container matColumnDef="orderNumber">
                        <th mat-header-cell *matHeaderCellDef class="text-primary"> N. ordine </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">N. ordine</span>
                            {{element.orderNumber}} </td>
                    </ng-container>
                    <ng-container matColumnDef="orderDate">
                        <th mat-header-cell *matHeaderCellDef> Data </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">Data</span>
                            {{element.orderDate | date}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Stato </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">Stato</span>
                            <ng-container *ngTemplateOutlet="status;context: { $implicit: element}"></ng-container>
                            <!-- {{element.status}} </td> -->
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef> Totale </th>
                        <td mat-cell *matCellDef="let element">
                        <span class="mobile-label">Totale</span>
                            {{element.total | currency}} </td>
                    </ng-container>

                    <ng-container matColumnDef="products">
                        <th mat-header-cell *matHeaderCellDef> Prodotti/servizi </th>
                        <td mat-cell *matCellDef="let element">
                        <span class="mobile-label">Prodotti/servizi</span>
                            {{element.products}} </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element">

                            <ng-container *ngFor="let item of actions">
                                <button *ngIf="!item.toshowFunction || item.toshowFunction(element)"
                                    mat-stroked-button color="primary" (click)="item.action(element)"
                                    [matTooltip]="item.tooltip ? item.tooltip : item.label ? item.label : ''">
                                    <mat-icon *ngIf="item.icon">{{item.icon}}</mat-icon><span
                                        *ngIf="item.label">
                                        
                                        {{downloading$() && item.label == 'Benchmark' ? 'Scaricando...' : item.label}}
                                    </span>
                                </button>
                            </ng-container>
                             </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="orderDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: orderDisplayedColumns;"></tr>
                </table>
            </ng-container>
        </mat-card-content>
    </mat-card>

</ng-template>
<ng-template #noData>
    <app-promo-marketplace [title]="'Non hai effettuato ordini.'" [template]="'orders'"></app-promo-marketplace>
</ng-template>
<ng-template #loader>
    <ngx-mare-skeleton [grid]="'2x4'" [template]="['title']"></ngx-mare-skeleton>
</ng-template>

<ng-template #status let-element>
    <ng-container [ngSwitch]="element.status">
        <ng-container *ngSwitchCase="'in attesa'">
            <span class="status--pending text-warning d-flex align-items-center gap-8"><span class="material-icons animation-rotation">hourglass_bottom </span> <b class="text-uppercase">{{element.status}}</b> </span>
        </ng-container>
         <ng-container *ngSwitchCase="'in elaborazione'">
            <span class="status--processing text-warning d-flex align-items-center gap-8"><span class="material-icons animation-rotation">settings</span> <b class="text-uppercase">{{element.status}}</b> </span>
        </ng-container>
        <ng-container *ngSwitchCase="'completato'">
            <span class="status--completed text-primary d-flex align-items-center gap-8"><span class="material-icons">done</span>  <b  class="text-uppercase">{{element.status}}</b> </span>
        </ng-container>
        <ng-container *ngSwitchCase="'cancellato'">

            <span class="status--canceled text-danger d-flex align-items-center gap-8"><span class="material-icons">cancel</span> <b  class="text-uppercase">{{element.status}}</b> </span>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <span class="status--pending"> {{element.status}} </span>
        </ng-container>
    </ng-container>
</ng-template>